export const biometricConstants = {
    BIO_RESULT_REQUEST: 'BIO_RESULT_REQUEST',
    BIO_RESULT_SUCCESS: 'BIO_RESULT_SUCCESS',
    BIO_RESULT_FAILURE: 'BIO_RESULT_FAILURE',
  }
  